import React, { memo } from 'react'
import classes from "./DefaultLabel.module.css"

const DefaultLabel = ({ label }) => {
    return (
        <label className={`${classes.defLabel}`}>{label}</label>
    )
}

export default memo(DefaultLabel)